module.exports = __webpack_public_path__ + "static/media/sasta-logo.5d4419cf.svg";